import http from '@/utils/request'

// 获取数据字典类型值 公共请求
export function dataDictionary(type){
    return http({
        // url: `system/dict/data/type/invent_news_type`,
        url: `system/dict/data/type/${type}`,
        method: 'GET'
    })
}
// 根据类型获取数据类型下的数据
export function listCommon(params) {
    return http({
        url: `invent/common/list`,
        method: 'GET',
        params
    })
}
export function askOrderAdd(data){
    return http({
        url: 'invent/askOrder/add',
        method: 'POST',
        data
    })
}
